/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  var video = $(".LP_video").find("video").get(0);
  $(".LP_video .speaker_off").on("click", function(){
    $(this).hide();
    $(this).siblings(".speaker_on").show();
    video.muted = false;
  })
  $(".LP_video .speaker_on").on("click", function(){
    $(this).hide();
    $(this).siblings(".speaker_off").show();
    video.muted = true;
  })
  

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

